module.exports = __webpack_public_path__ + "static/media/received_1517480104933156.1029b4e6.jpg";